<nav
  class="main-nav-list"
  [style.width]="this.isSideMenuOpen() ? '75px' : '97%'"
>
  <ul class="list">
    @for (sideMenuItem of sideMenuItems; track $index) {
    <li class="list-item">
      <a
        class="link"
        [routerLink]="[
          sideMenuItem.route(this.selectedCourseSection?._id ?? '')
        ]"
        [relativeTo]="route"
        [ngClass]="{ active: this.isCurrentRouteActive(sideMenuItem) }"
      >
        <img
          class="image"
          [src]="this.getSideMenuItemIcon(sideMenuItem)"
          [alt]="sideMenuItem.alt"
        />
        <span class="hidden" [hidden]="this.isSideMenuOpen()">{{
          sideMenuItem.translationPath | translate
        }}</span>
      </a>
    </li>
    } @if (selectedCourseSection?.isJustificationRequired === true) {
    <li class="list-item">
      <a
        class="link"
        routerLink="outlier-justification"
        [relativeTo]="route"
        [ngClass]="{ active: this.isOutlierJustificationActive() }"
      >
        <img
          class="image"
          [src]="this.getOutlierJustificationIcon()"
          alt="Outlier justification"
        />
        <span class="hidden" [hidden]="this.isSideMenuOpen()">{{
          "courseSections.outlierJustification" | translate
        }}</span>
      </a>
    </li>
    }
  </ul>
</nav>
